module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0041.png.d7529fb5.jpg";